import React, { useRef, useEffect, useState } from "react";
import styles from "../../styles/main.module.css";
import CardsGrid from "./cardsGrid";
import SectionTop from "./sectionTop";
import SectionSobreMi from "./sectionSobreMi";
import Tecnoligias from "./tecnologias";
import Educacion from "./educacion";
import Contacto from "./contacto";
//-----------------------------
export default function DivMain({ scroll }) {
  useEffect(() => {
    if (scroll) {
      const element = document.getElementById(`${scroll}-section`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [scroll]);

  return (
    <div className={styles.main}>
      <SectionTop id="top-section" />
      <SectionSobreMi id="sobreMi-section" />
      <CardsGrid id="portafolio-section" />
      <Tecnoligias id="tecnologias-section" />
      <Educacion id="educacion-section" />
      <Contacto id="contacto-section" />
    </div>
  );
}
